import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { Page } from '../components';
import { reactPlugin } from "../AppInsights";
import { AckAllButton, AlarmList, StatefulAckAllButton } from '../features/Alarm'
import { useIntl, FormattedMessage } from 'react-intl';
import React from "react";
import { useStyletron } from "baseui";

const Alarms = () => {
    const intl = useIntl();
    const [css, theme] = useStyletron();
    
    return (
        <Page
            header={intl.formatMessage({ id: "Pages.Alarms.header", defaultMessage: "Alarms" })}
            subheader={intl.formatMessage({ id: "Pages.Alarms.subheader", defaultMessage: "A list of all alarms and events in your facility ordered by new alarms first, gone alarms second and acknowledged ones at last" })}
            bottomButtons={[<StatefulAckAllButton />]}>
            <AlarmList></AlarmList>
        </Page >
    )
}


export default React.memo(withAITracking(reactPlugin, Alarms));